import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
Vue.use(Router)

const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err) // 暂时屏蔽路由警告
}
import store from '@/store'

// *注意站点模板路由在store/app，setSiteTemplateRoute中设置
const routes = [

]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('user/needRefreshToken')
  store.dispatch('user/startWatchToken')
  store.commit('app/cancelRequesting')
  if (!Cookies.get('token')) {
    localStorage.getItem('userinfo') && localStorage.removeItem('userinfo')
  } else {
    store.commit('user/setUserinfo', JSON.parse(window.localStorage.getItem('userinfo')) || {})
  }

  if(to.meta.isLogin){
    if(Cookies.get('token')){
      next()
    }else{
      next('/')
    }
  }
  next()
})

export default router

